import React, {Component} from 'react';
import styled from '@emotion/styled'
import Loader from 'react-loader-spinner'



import {
  IbanElement,
  injectStripe,
  StripeProvider,
  Elements,
} from 'react-stripe-elements';


const StyledSpinner = styled.div`
width:100%;
height:100%;
transform: rotate(180deg);
display:flex;
justify-content:center;
align-items:center;

`

const Wrapper = styled.div`

.ElementsApp, .ElementsApp .InputElement{
font-size:18px;
}
`

const PayButton = styled.button`
cursor:pointer;
width:98%;
margin-bottom:10px;
margin-top:20px;
height:42px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem !important;
  color: #fff;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:19px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;

  
:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: #188cec;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #54aaf1;
  border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: #fff;
}
 
:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
z-index:999999;
}


`

const Label = styled.label`
input{
width:100% !important;
}

input:focus{
box-shadow:rgba(50,50,93,0.14902) 0px 1px 3px,rgba(0,0,0,0.0196078) 0px 1px 0px;
}


padding-left:6px;
font-weight:bold;
`

import config from '../../utils/config';
import {createPaymentIntent} from "./functions";
import {navigate} from "@reach/router";
import {fonts} from "../../styles/variables";
//import {getFullName} from "../auth/authFunctions";
// You can customize your Elements to give it the look and feel of your site.
const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};
class _GiropayForm extends React.Component {

  state = {
    errorMessage: '',
    paymentIntent:null,
    amount:this.props.amount,
    showSpinner:false


  };

  handleChange = ({error}) => {
    if (error) {
      this.setState({errorMessage: error.message});
    }
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    if (this.props.stripe) {
      this.props.stripe
        .createSource({
          type: 'giropay',
          amount: 1099,
          currency: 'eur',
          owner: {
            name: 'Jenny Rosen',
          },
          redirect: {
            return_url: 'https://shop.example.com/crtA6B28E1',
          }
        }).then((source) => {
          //console.log(source)
 //navigate(source.source.klarna.pay_now_redirect_url)


      })
        .catch((err) => { // Error response
          //console.log(err);

    })


  } else {
      //console.log("Stripe.js hasn't loaded yet.");
    }
  };
  handleReady = () => {
    //console.log('[ready]');
  };



  render() {
    return (
<div>
  <StyledSpinner>
    <Loader
      type="Triangle"
      color="black"
      height={66}
      width={66}
      // timeout={30000} //3 secs

    />
  </StyledSpinner >

</div>
    );
  }
}

const GiropayForm = injectStripe(_GiropayForm);

export class GiropayDemo extends Component<any,any> {
  constructor(props) {
    super(props);

    this.state = {
      stripe: null,
      countdown: 1,
    };
  }

  componentDidUpdate(){
    const postBooking = this.props.postBooking
    const amount = this.props.amount

    if (this.state.stripe) {
      this.state.stripe
        .createSource({
          type: 'giropay',
          amount: this.props.amount,
          currency: 'eur',

          redirect: {
            return_url: 'http://localhost/booking_pending',
            return_url: 'http://localhost/booking_pending',
          }
        }).then((source) => {
        //console.log(source)
        if(source.status!=null && source.status!=undefined) {
          //thanks to stripe webhooks, nothing to do here anymore, just navigate to pending_success page

          //  navigate(source.source.redirect.url)
          navigate('http://localhost/booking_pending')
        }

      })
        .catch((err) => { // Error response
          //console.log(err);

        })


    } else {
      //console.log("Stripe.js hasn't loaded yet.");
    }
  }

  componentDidMount() {
    // componentDidMount only runs in a browser environment.
    // In addition to loading asynchronously, this code is safe to server-side render.

    // Remove our existing Stripe script to keep the DOM clean.
    // document.getElementById('stripe-script').remove();
    // You can inject a script tag manually like this,
    // or you can use the 'async' attribute on the Stripe.js v3 <script> tag.
    const stripeJs = document.createElement('script');
    stripeJs.id = 'stripe-script';
    stripeJs.src = 'https://js.stripe.com/v3/';
    stripeJs.async = true;
    stripeJs.onload = () => {
      const countdown = setInterval(() => {
        this.setState({countdown: this.state.countdown - 1});
      }, 1000);
      // The setTimeout lets us pretend that Stripe.js took a long time to load
      // Take it out of your production code!
      setTimeout(() => {
        clearInterval(countdown);
        this.setState({
          stripe: window.Stripe('pk_live_FrncSr45TM7v7k9MzczmpLlI00iT1gKayE'),
        });
      }, 1000);
    };
    document.body && document.body.appendChild(stripeJs);




  }


  render() {

    return (
      <Wrapper >
      <StripeProvider stripe={this.state.stripe}>
        <Elements>
          <GiropayForm  countdown={this.state.countdown}
                    amountToPay={this.props.amountToPay} fullAmount={this.props.fullAmount}
                     guests={this.props.guests} nights={this.props.nights}
                     rooms={this.props.rooms} categories={this.props.categories}
                     payOption={this.props.payOption}
                      startDate={this.props.startDate} endDate={this.props.endDate}
                     handleResult={this.props.handleResult} />
        </Elements>
      </StripeProvider>
      </Wrapper>
    );
  }
}
